<!--日期 DATE-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{
                `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
              }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>日期</p>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div class="input-container" style="border: 1px solid #dcdde0">
        <input
          placeholder-class="input-placeholder"
          type="text"
          placeholder="日期"
          v-model="caseProblem"
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          class="input-container-input"
        />
      </div>
      <div class="input-container">
        <p class="input-container-text">日期</p>
      </div>
    </div>
    <div class="must-container custom-check-box">
      <el-checkbox
        label="必选题"
        v-model="isMust"
        :true-label="1"
        :false-label="0"
        class="custom-checkbox"
        @change="handleCheckboxChange"
      ></el-checkbox>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
    };
  },
  methods: {
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    cancelClick() {
      // this.dataObj.isMust = this.isMust ? 1 : 0;
      // this.dataObj.caseProblem = this.caseProblem;
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        this.$message.error("请输入题目");
      }

      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "日期" : this.caseProblem;
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleClick() {},
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        console.log("dataObj 变化了", newVal, oldVal);
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.isMust = newVal.isMust === 1;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditDate.vue